import script from "./OrderRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderRecord.vue?vue&type=script&setup=true&lang=js"

import "./OrderRecord.vue?vue&type=style&index=0&id=6ffb3b22&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ffb3b22"]])

export default __exports__